import { render } from "./SectionBasic.vue?vue&type=template&id=191b5baa&scoped=true"
import script from "./SectionBasic.vue?vue&type=script&lang=js"
export * from "./SectionBasic.vue?vue&type=script&lang=js"

import "./SectionBasic.vue?vue&type=style&index=0&id=191b5baa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191b5baa"]])

export default __exports__